import {
  MIVO_WORDMARK_DOTLESS_I,
  mivoWordMarkPeachDotStyle,
  mivoWordMarkRootStyle,
} from "./mivoWordMarkStyle";

type MivoWordMarkProps = {
  fontSize?: string;
  color?: string;
};

export default function MivoWordMark({ fontSize = "70px", color = "#224D3C" }: MivoWordMarkProps) {
  return (
    <div style={mivoWordMarkRootStyle(fontSize)} aria-label="Mivo">
      <span style={{ color }}>M</span>
      <span style={{ position: "relative", display: "inline-block", color }}>
        {MIVO_WORDMARK_DOTLESS_I}
        <span aria-hidden style={mivoWordMarkPeachDotStyle()} />
      </span>
      <span style={{ color }}>vo</span>
    </div>
  );
}
